
/* eslint-disable react/function-component-definition,react/function-component-definition,no-restricted-syntax, jsx-a11y/label-has-associated-control */

import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
// import { useCountryName } from "./useCountryName"; // optional: see note below


// const DEFAULT_COUNTRIES = [
//     { countryCode: "20",  countryName: "EGYPT",           countryId: "EG",  company: "Vodafone", defaultGroupName: "Egypt" },
//     { countryCode: "231", countryName: "Ethiopia",        countryId: "ET",  company: "Vodafone", defaultGroupName: "Ethiopia" },
//     { countryCode: "243", countryName: "DRC",             countryId: "CD",  company: "Vodafone", defaultGroupName: "DRC" },
// ]  

export default function CountrySelect(props) {
  const {
    setDialogOpenCountry,          // optional: may be used to close dialog
    getCountriesList,              // optional: prefer this if provided
    postAddCountryAcceptenceFn,    // required: submit handler
    loginUser,
                         // used for isCommunityAssigned
    currentDomain,                 // included in payload
    userEmail,                     // included in payload
    defaultCountryId = ""          // optional: preselect country (e.g., "IN")
  } = props;

  const { isCommunityAssigned } = loginUser || {};

  // Prefer the list from props; fallback to default list
  const countries = useMemo(() => {
    const list = Array.isArray(getCountriesList) && getCountriesList.length
      ? (getCountriesList || [])
      : [] ;

    // Optional: sort alphabetically by name (case-insensitive)
    return [...list].sort((a, b) =>
      String(a.countryName).localeCompare(String(b.countryName), undefined, { sensitivity: "base" })
    );
  }, [getCountriesList]);

  // Fast lookup by id
  const countryById = useMemo(() => {
    const map = {};
    for (const c of countries) {
      map[String(c.countryId)] = c;
    }
    return map;
  }, [countries]);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting, isValid }
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: { country: defaultCountryId || "" },
  });

  const onSubmit = async (data) => {
    // Validate/resolve the chosen country
    const selectedId = String(data?.country || "");
    const match = countryById[selectedId];

    if (!match) {
      setError("country", { type: "validate", message: "Invalid country selected" });
      return;
    }

    const payload = {
      email: userEmail,
      countryId: match.countryId,
      countryName: match.defaultGroupName,
      isCommunityAssigned: Boolean(isCommunityAssigned),
      domainName: currentDomain,
    };

    // Submit payload to your API
    await Promise.resolve(postAddCountryAcceptenceFn(payload));

    // Optionally close the dialog
    setDialogOpenCountry?.(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <label htmlFor="country" style={{ display: "block", marginBottom: 8 }}>
        Market / Subsidiary <span style={{ color: "crimson" }}>*</span>
      </label>

      <select
        id="country"
        {...register("country", {
          required: "Please select your Market or Subsidiary",
          validate: (val) => (val && String(val).trim().length > 0) || "Please select your Market or Subsidiary"
        })}
        aria-invalid={!!errors.country || undefined}
        aria-describedby={errors.country ? "country-error" : undefined}
        style={{
          width: "100%",
          padding: 8,
           height:'48px',
          borderRadius: 6,
          border: errors.country ? "1px solid crimson" : "1px solid #ccc"
        }}
      >
        <option value="" disabled>
          Select your Market or Subsidiary
        </option>
        {countries.map((c) => (
          <option key={String(c.countryId)} value={String(c.countryId)}>
            {c.countryName}
          </option>
        ))}
      </select>

      {errors.country && (
        <div id="country-error" role="alert" style={{ color: "crimson", marginTop: 6 }}>
          {errors.country.message}
        </div>
      )}

      <button
        type="submit"
        disabled={isSubmitting || !isValid}
        style={{ display: "block", marginTop: 16, fontSize:'1rem', fontFamily:'VodafoneLt-Regular', backgroundColor:"red",color:'#fff',padding:'8px', border:'0px', borderRadius:'8px' }}
      >
        Submit
      </button>
    </form>
  );
}
